module.exports = __webpack_public_path__ + "static/media/group@3x.65385036.png";